module.exports = __webpack_public_path__ + "img/cx_teste_covid_flu.fe5fd4b6.webp";